<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.shortName"
                  label="Short Name"
                  :error-messages="[].concat(fieldErrors('form.shortName'))"
                  @blur="$v.form.shortName.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.name"
                  label="Item Name"
                  :error-messages="[].concat(fieldErrors('form.name'))"
                  @blur="$v.form.name.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.description"
                  label="Description"
                  :error-messages="[].concat(fieldErrors('form.description'))"
                  @blur="$v.form.description.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.price"
                  label="Price"
                  type="number"
                  :error-messages="fieldErrors('form.price')"
                  @blur="$v.form.price.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="form.cost"
                  label="Cost"
                  type="number"
                  :error-messages="fieldErrors('form.cost')"
                  @blur="$v.form.cost.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <type-select
                  v-model="form.type"
                  label="Type"
                  :error-messages="[].concat(fieldErrors('form.type'))"
                  @blur="$v.form.type.$touch()"
                ></type-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <tags-select
                  v-model="form.tags"
                  label="Tags"
                  :filter-word="form.type"
                  :error-messages="[].concat(fieldErrors('form.tags'))"
                  @blur="$v.form.tags.$touch()"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState, mapGetters } from "vuex";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import TagsSelect from "components/TagSelect.vue";
import TypeSelect from "components/TypeSelect";

export default {
  components: {
    AlertMessage,
    TagsSelect,
    TypeSelect,
  },
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },
  mixins: [validationMixin],
  validations: {
    form: {
      shortName: {
        required,
      },
      name: { required },
      type: { required },
      price: { required },
      cost: { required },
      description: {},
      category: {},
      tags: {},
    },
  },
  validationMessages: {
    form: {
      shortName: {
        required: "Shortname required",
      },
      name: {
        required: "Name required",
      },
      category: {},
      type: {
        required: "Type required",
      },
      price: {
        required: "Price required",
      },
      cost: {
        required: "Cost required",
      },
      description: {
        required: "Description required",
      },
      tags: {
        required: "Description required",
      },
    },
  },

  data() {
    return {
      showDialog: this.show,
      typeItems: ["Labor", "Parts"],
      form: {
        id: "",
        shortName: "",
        name: "",
        type: "Labor",
        price: 0,
        description: "",
        internalNote: "",
        category: "",
        tags: [],
        cost: 0,
      },

      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
    item(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ..._.pick(n, _.keys(this.form)),
          tags: n.categories ? n.categories.map((c) => c.id) : [],
        };
      }
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
    formTitle() {
      return this.isEdit ? "Edit Item" : "Add Item";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
  },

  created() {},

  methods: {
    ...mapActions("item", ["create", "update"]),
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },
    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });
    },
    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        id: "",
        shortName: "",
        name: "",
        type: "Labor",
        price: "0",
        description: "",
        internalNote: "",
        cost: 0,
      };
    },

    completed() {
      this.$emit("onSucceded");
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        id: this.form.id,
        item: {
          ...this.form,
          accountId: UTIL.gv(this.account, "data.user.accountId", ""),
        },
        tags: this.form.tags,
      };

      if (this.isEdit) {
        await this.update(payload);
      } else {
        delete payload.item.id;
        await this.create(payload);
      }

      if (!this.account.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>